const BaseComponent = require( 'base/base-component' );
const Server = require( 'helper/server' );
const secuntry = require( 'helper/secuntry' );

const loginModalTpl = Handlebars.templates[ 'purchasing-federation/common/toplinev2/templates/login' ];

class TopLineV2 extends BaseComponent {
  constructor() {
    super( {
      events: {
        'click .logout': 'logout',
        'click .member-login': 'memberLogin',
        'click .loginModalSummit': 'loginSubmit',
        'click .loginModalClose': 'closeModal',
        'click .top-captchaimg': 'captchaimg'
      }
    } );
  }

  init() {
    const date = new Date();
    const hour = date.getHours();
    let _t = '';
    if (hour <= 24 && hour > 17 || hour < 5) {
      _t = '晚上好 ,';
    } else if (hour < 12) {
      _t = '上午好 ,';
    } else if (hour <= 17) {
      _t = '下午好 ,';
    }
    this.$el.find( '.welcome' ).prepend( _t );
    this.initLogin();
  }

  memberLogin() {
    const loginModal = $( '#site-login-modal' );
    const time = Date.now();
    const src = `/business/front/login/captcha?d=${ time }`;
    const formHtml = loginModalTpl( { SRC: src } );
    loginModal.find( '.modal-body' ).html( formHtml );
    loginModal.modal( 'show' );
  }

  async initLogin() {
    const data = await Server.purchaseGetLoginUser();
    if (data) {
      // 已登录
      $( 'body' ).find( '.inner-container .loginedwrap .uername, .logined .greetings .name' ).text( data );
      $( 'body' ).find( '.logined, .loginedwrap' ).show();
      $( 'body' ).find( '.unlogin, .unloginwrap' ).hide();
      $( 'body' ).find( '.ZCY-comp-topline-v2 .submission' ).show();
      $( 'body' ).find( '.ZCY-comp-topline-v2 .message-center' ).show();
    } else {
      // 未登录
      $( 'body' ).find( '.logined, .loginedwrap' ).hide();
      $( 'body' ).find( '.unlogin, .unloginwrap' ).show();
      $( 'body' ).find( '.ZCY-comp-topline-v2 .submission' ).hide();
      $( 'body' ).find( '.ZCY-comp-topline-v2 .message-center' ).hide();
      // const isHome = $( '#memberHome.logined ' ).length;
      // const isNeedLogin = $( '#page-is-need-login' ).val();
      // if (!isHome && isNeedLogin == 1) {
      //   window.location = '/home.html';
      // }
    }
  }

  async loginSubmit() {
    const loginModal = $( '#site-login-modal' );
    const memberName = loginModal.find( '[name="username"]' ).val();
    const password = loginModal.find( '[name="password"]' ).val();
    const captcha = loginModal.find( '[name="captcha"]' ).val();
    const payload = {
      password: secuntry.encode( password ),
      memberName,
      captcha
    };
    // const spiner = this.$el.find( '.login-wrap' ).spin();
    // console.log(payload)
    // return
    try {
      const { success, result, error } = await Server.purchaseLogin( payload ) || {};
      // spiner.stop();
      if (success) {
        $( 'body' ).find( '.inner-container .loginedwrap .uername, .logined .greetings .name' ).text( result );
        $( 'body' ).find( '.logined, .loginedwrap' ).show();
        $( 'body' ).find( '.unlogin, .unloginwrap' ).hide();
        $( 'body' ).find( '.ZCY-comp-topline-v2 .submission' ).show();
        $( 'body' ).find( '.ZCY-comp-topline-v2 .message-center' ).show();
        loginModal.modal( 'hide' );
      } else {
        ZCY.utils.modal( {
          type: 'error',
          cls: 'as-modal',
          container: $( '.ZCY-comp-topline-v2' ),
          button: [ '确定' ],
          content: [ error ]
        } );
      }
    }
    catch ( e ) {
      alert( e.responseText || '未知错误' );
    }
  }

  async logout() {
    const res = await Server.purchaseLogout();
    if (res) {
      $( 'body' ).find( '.inner-container .loginedwrap .uername, .logined .greetings .name' ).text();
      $( 'body' ).find( '.logined, .loginedwrap' ).hide();
      $( 'body' ).find( '.unlogin, .unloginwrap' ).show();
      const isHome = $( '#memberHome.logined ' ).length;
      // const isNeedLogin = $( '#page-is-need-login' ).val();
      if (!isHome) {
        window.location = '/home.html';
      }
    }
  }

  closeModal() {
    const loginModal = $( '#site-login-modal' );
    const taregt = $( '#memberHome .captchaimg' );
    if (taregt.length) {
      const time = Date.now();
      let src = `/business/front/login/captcha?d=${ time }`;
      taregt.attr( 'src', src );
    }
    loginModal.modal( 'hide' );
  }

  captchaimg( e ) {
    const time = Date.now();
    let src = `/business/front/login/captcha?d=${ time }`;
    if (e) {
      const el = e.target || e.srcElement;
      $( el ).attr( 'src', src );
    } else {
      $( '.top-captchaimg' ).attr( 'src', src );
    }
  }
}

module.exports = TopLineV2;
